/**
 * 用户管理
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getFormDetail(keyId) {
    return request(api.comm.SCHEDULE + "/" + keyId, METHOD.GET);
  },
  async saveFormDetail(result) {
    return request(api.comm.SCHEDULE, METHOD.POST, result);
  },
  async execute(result) {
    return request(api.comm.SCHEDULE + "/run", METHOD.POST, result);
  },
  async pause(result) {
    return request(api.comm.SCHEDULE + "/pause", METHOD.POST, result);
  },
  async restore(result) {
    return request(api.comm.SCHEDULE + "/resume", METHOD.POST, result);
  },
  async showLog(result) {
    return request(api.comm.SCHEDULE, METHOD.GET, result);
  }
}


export default {dataApi}
